class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
   
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      
      // Initialize slider components when drawer is fully opened
      this.initializeSliderComponents();
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(async () => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Check cart items after content update
      if (window.CartSamples && window.CartSamples.checkCartItems) {
        try {
          await window.CartSamples.checkCartItems();
        } catch (error) {
          console.error('Error checking cart items:', error);
        }
      }
      
      // Initialize slider components after content loads
      this.initializeSliderComponents();
      
      this.open();
    }, 100);
  }

  initializeSliderComponents() {
  
    const productRecommendations = this.querySelector('product-recommendations');
    if (productRecommendations) {
      

      if (productRecommendations.innerHTML.trim().length === 0) {
        const dataUrl = productRecommendations.dataset.url;
        if (dataUrl) {
    
          fetch(dataUrl)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              
              if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendations.innerHTML = recommendations.innerHTML;
              
                setTimeout(() => this.initializeSliderComponents(), 100);
              }
            })
            .catch(e => {
              console.error('Failed to load recommendations in cart drawer:', e);
            });
          return;
        }
      }
      
    
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {

            const sliderComponent = productRecommendations.querySelector('slider-component');
            if (sliderComponent && !sliderComponent.hasAttribute('data-initialized')) {

              sliderComponent.setAttribute('data-initialized', 'true');
              

              setTimeout(() => {
                if (sliderComponent.initPages && typeof sliderComponent.initPages === 'function') {
                  sliderComponent.initPages();
                }
                
              
                window.dispatchEvent(new Event('resize'));
              }, 50);
              

              observer.disconnect();
            }
          }
        });
      });
      

      observer.observe(productRecommendations, {
        childList: true,
        subtree: true
      });
      

      const existingSlider = productRecommendations.querySelector('slider-component');
      if (existingSlider && !existingSlider.hasAttribute('data-initialized')) {
        existingSlider.setAttribute('data-initialized', 'true');
        setTimeout(() => {
          if (existingSlider.initPages && typeof existingSlider.initPages === 'function') {
            existingSlider.initPages();
          }
          window.dispatchEvent(new Event('resize'));
        }, 50);
      }
      
  
      setTimeout(() => {
        observer.disconnect();
      }, 5000);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        

        if (window.CartSamples && window.CartSamples.checkCartItems) {
          window.CartSamples.checkCartItems();
     
          if (window.CartSamples.initializeEventListeners) {
            window.CartSamples.initializeEventListeners();
          }
        }


        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.initializeSliderComponents) {
          setTimeout(() => {
            cartDrawer.initializeSliderComponents();
          }, 100);
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== undefined) {
          if (updatedValue === 1) {
            message = window.cartStrings.oneCartItem;
          } else {
            message = window.cartStrings.otherCartItems.replace('[count]', updatedValue);
          }
          this.updateLiveRegions(line, message);
        }

        const lineItem = document.getElementById(`CartDrawer-Item-${line}`) || document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper.querySelector(`[name="${name}"]`).focus();
        }
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('CartDrawer-CartErrors') || document.getElementById('CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  async renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));


    if (window.CartSamples && window.CartSamples.checkCartItems) {
      try {
        await window.CartSamples.checkCartItems();
     
        if (window.CartSamples.initializeEventListeners) {
          window.CartSamples.initializeEventListeners();
        }
      } catch (error) {
        console.error('Error checking cart items:', error);
      }
    }


    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.initializeSliderComponents) {
      setTimeout(() => {
        cartDrawer.initializeSliderComponents();
      }, 100);
    }

    this.disableLoading();
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
